import { Checkbox, DataListHeader } from 'mailup-web-components'
import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { selectedResultsStateAllSelected } from '../recoil/state/result'

const SelectAll = () => {
  const intl = useIntl()

  const [allSelected, setAllSelected] = useRecoilState(
    selectedResultsStateAllSelected,
  )

  const { current: handleChange } = useRef((e) => {
    setAllSelected(e.target.checked)
  })

  const heads = [
    {
      label: (
        <Checkbox
          checked={allSelected}
          onChange={handleChange}
          label={
            allSelected
              ? intl.formatMessage({ id: 'Load.TableHeader.UnselectAll' })
              : intl.formatMessage({ id: 'Load.MailupCommon.BtnSelectAll' })
          }
          labelClassName="text-light"
          data-mu-test="checkbox--select-all"
        />
      ),
      span: 3,
    },
  ]

  return <DataListHeader heads={heads} />
}

export default SelectAll
